export class DynamicAddRow{     
    WarehouseCode:string;  
    WarehouseLocation:string;  
    ItemCode:string; 
    ItemName:string;  
    PackSize:string;  
    StockReceiptDate:string;  
    ReceivedThrough:string;
    ReceivedFrom:string;
    BatchNo:string;
    QtyMentionedInDoc: string;
    ActualQtyReceived: string;
    NoofCase:string;
    MFGDate:string;
    EXPDate:string;
    DocNo:string;
    InvNo:string;
    INVDate:string;
} 

export class UploadExcel {
    UserId: string;
    file:File;
}
